export default __webpack_public_path__ + "images/cb40fccc4b9fd7d591e19cc0289fa9ee.png";